import i8n from "@/i18n";

const escape = (message) => message.replace(/[.]/g, "").replace(/[']/g, "&#39;");

const fromServer = (responseData, data) => {
  // TODO: Review this conversion
  if (responseData === Object(responseData) && !Array.isArray(responseData)) {
    responseData = Object.values(responseData);
  }

  if (Array.isArray(responseData)) {
    return responseData.map((resp) => i8n.t(`server.${escape(resp)}`, data));
  }

  return i8n.t(`server.${escape(responseData)}`, data);
};

export { fromServer };
